<div
  class="gd-list-table-cell-obfuscate"
  fxLayout="row">

  <!-- Value -->
  <div
    class="gd-list-table-cell-obfuscate-value"
    fxFlex>
    {{notObfuscated ? value : '***'}}
  </div>

  <!-- Hide / Show -->
  <div
    fxGrow="0">
    <button
      type="button"
      mat-icon-button
      (click)="notObfuscated = !notObfuscated">
      <mat-icon>{{notObfuscated ? 'visibility' : 'visibility_off'}}</mat-icon>
    </button>
  </div>

</div>
